import { RefObject, useEffect, useRef, useState } from 'react';

const useFirstViewportEntry = (ref: RefObject<HTMLDivElement | null>, observerOptions: IntersectionObserverInit) => {
  const [entered, setEntered] = useState(false);
  const observer = useRef(new IntersectionObserver(([entry]) => setEntered(entry?.isIntersecting), observerOptions));

  useEffect(() => {
    const el = ref.current;
    const ob = observer.current;

    // stop observing once entered first:
    if (entered) {
      ob.disconnect();
      return;
    }

    if (el && !entered) ob.observe(el);

    return () => ob.disconnect();
  }, [entered, ref]);

  return entered;
};

export { useFirstViewportEntry };
